import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  LocationSuggestion,
  UserLocation
} from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-show-charging-location-modal',
  templateUrl: './show-charging-location-modal.component.html',
  styleUrls: ['./show-charging-location-modal.component.scss']
})
export class ShowChargingLocationModalComponent {
  @Input() chargingLocation: UserLocation;

  constructor(private modalCtrl: ModalController) {}

  cancel() {
    this.modalCtrl.dismiss({
      chargingLocation: this.chargingLocation
    });
  }
}
